let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("OgDz0")).then(() => parcelRequire('gEdc8'));